export default function PlusBlackIcon({ className }: { className?: string }) {
  return (
    <svg
      className={`text-i-gray hover:text-i-black ${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 4.16699V15.8337M4.16699 10.0003H15.8337"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const displayName = "PlusBlackIcon";
